let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("71TFb")).then(() => parcelRequire('av1JP'));